module.exports = __webpack_public_path__ + "static/media/sprites.9136e505.svg";